/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunneltitle3Inputs */

const en_liveroomfunneltitle3 = /** @type {(inputs: Liveroomfunneltitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

const de_liveroomfunneltitle3 = /** @type {(inputs: Liveroomfunneltitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

/**
* | output |
* | --- |
* | "Live Room" |
*
* @param {Liveroomfunneltitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunneltitle3 = /** @type {((inputs?: Liveroomfunneltitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunneltitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunneltitle3(inputs)
	return de_liveroomfunneltitle3(inputs)
});
export { liveroomfunneltitle3 as "liveRoomFunnelTitle" }